module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-顶部修饰图.738fb084.png";